import { createFileRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router'

import type { FileRoutesByTo } from '@/routeTree.gen'

import { BookingError } from '@/components/booking/booking-error'
import { BookingStepper } from '@/components/booking/booking-stepper'
import { BlueHeader } from '@/components/layout/blue-header'

const STEP_ROUTES: Record<number, keyof FileRoutesByTo> = {
  1: '/research-bar',
  2: '/informations',
  3: '/assurances',
  4: '/checkout',
}

export const Route = createFileRoute('/_booking')({
  component: BookingLayout,
  errorComponent: BookingError,
})

function BookingLayout() {
  const navigate = useNavigate()
  const routerState = useRouterState()
  const currentPath = routerState.location.pathname

  const currentStep = currentPath.includes('/informations')
    ? 2
    : currentPath.includes('/assurances')
      ? 3
      : currentPath.includes('/checkout') || currentPath.includes('/paiement')
        ? 4
        : 1

  const sessionId = (routerState.location.search as { session?: string }).session

  const handleStepClick = (step: number) => {
    if (step >= currentStep) return
    const route = STEP_ROUTES[step]
    if (!route) return

    if (step === 1) {
      void navigate({ to: route })
    } else if (sessionId) {
      void navigate({ search: { session: sessionId }, to: route })
    }
  }

  return (
    <div className="flex min-h-full w-full flex-col bg-[url('/images/default-background.jpg')] bg-cover bg-fixed bg-center bg-no-repeat">
      <BlueHeader />
      <div className="flex w-full flex-1 flex-col bg-white">
        <BookingStepper currentStep={currentStep} onStepClick={handleStepClick} />
        <div className="flex w-full flex-1 flex-col">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
